import * as React from 'react';
import BodyPortal from '@sdk/common/tooltip/BodyPortal';

import Item from './Item/Item';
import { useListSettings, usePosition, useScrollToItem } from './mentionSuggestions.hooks';
import { StyledList, Wrapper } from './mentionSuggestions.styles';
import { MentionSuggestionsProps as Props } from './mentionSuggestions.types';

export const MentionSuggestions: React.FC<React.PropsWithChildren<Props>> = ({ mentionsState }) => {
  const itemsCount = mentionsState.filteredPersonas.length;

  const settings = useListSettings(itemsCount);
  const position = usePosition(itemsCount, mentionsState.target);
  const ref = useScrollToItem(mentionsState.index);

  return (
    <BodyPortal>
      <Wrapper {...position}>
        <StyledList ref={ref} itemData={mentionsState} {...settings}>
          {Item}
        </StyledList>
      </Wrapper>
    </BodyPortal>
  );
};
